import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const SkeletonWithMargin = styled(Skeleton)`
  margin: ${spacing.base} 0;
`;

const HeaderContainer = styled.div`
  margin: ${spacing.double} 0;
`;

const ContentContainer = styled.div`
  margin: ${spacing.double} 0;
`;

export const MetricsLoadingSkeleton = () => {
  return (
    <>
      <HeaderContainer>
        <SkeletonWithMargin key={1} height={36} />
      </HeaderContainer>
      <ContentContainer key={1}>
        <SkeletonWithMargin key={2} height={36} width={100} />
        <SkeletonWithMargin key={3} height={24} />
        <SkeletonWithMargin key={4} height={24} />
        <SkeletonWithMargin key={5} height={24} />
        <SkeletonWithMargin key={6} height={24} />
      </ContentContainer>
      <ContentContainer key={2}>
        <SkeletonWithMargin key={7} height={36} width={100} />
        <SkeletonWithMargin key={8} height={24} />
        <SkeletonWithMargin key={9} height={24} />
        <SkeletonWithMargin key={10} height={24} />
        <SkeletonWithMargin key={11} height={24} />
      </ContentContainer>
    </>
  );
};
